import { render } from "./GurtniPage.vue?vue&type=template&id=c2a9afa0&scoped=true"
import script from "./GurtniPage.vue?vue&type=script&lang=js"
export * from "./GurtniPage.vue?vue&type=script&lang=js"

import "./GurtniPage.vue?vue&type=style&index=0&id=c2a9afa0&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a9afa0"]])

export default __exports__